import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {
    ContentDetailTwoColLayout,
    DetailEntityShell,
    DetailFilePanel,
    DetailHeroSummaryProvider,
    DetailKvListValue,
    KV_LIST_TYPES,
    DetailKvReadOnly,
    DetailKvTable,
    DetailPanel,
    DetailTabBar,
    useDetailEditing,
} from "../../../../components/detailLayout";
import "../../../../components/detailLayout/detailListLayout.css";
import "../info/subPages/view/assetInfo.css";
import "./licenseForm.css";
import SearchSelector from "../../../../components/searchSelector/SearchSelector";
import UserSelectionField from "../../../../components/selection/UserSelectionField";
import {
    addLicenseKeyById,
    deleteLicenseKeyById,
    getLicense,
    updateLicense,
    updateLicenseHandler,
    updateLicenseKey,
    updateLicenseKeyAsset
} from "../../../../api/asset/LicenseService";
import {useDispatch, useSelector} from "react-redux";
import Th_title from "../../../../components/Th_title";
import {UserType} from "../../../../constant/CodeSpecNum";
import {refresh, skeleton} from "../../../../redux/slice/apiSlice";
import {inputOnChange, inputOnKeyDown} from "../../../../components/commonmethod/simmsInputMethod";
import SimmsInput from "../../../../components/input/SimmsInput";
import SimmsTextArea from "../../../../components/input/SimmsTextArea";
import SimmsDatePicker from "../../../../components/datepicker/SimmsDatePicker";
import {dateOnChange, dateOnSelected} from "../../../../components/commonmethod/simmsDateMethod";
import dayjs from "dayjs";
import {cn} from "../../../../shadCn/lib/utils";
import {CommonHistoryList} from "../../../settings/history/subPages/CommonHistoryList";
import SimmsInputSearch from "../../../../components/input/SimmsInputSearch";
import SimmsDrawerSearch from "../../../../components/drawer/simms/SimmsDrawerSearch";
import {LicenseKeyEditor} from "./shared/LicenseKeyEditor";

/**
 * &라이선스 상세보기
 * */

function LicenseView() {
    const platFrom = useSelector(state =>state.auth.platFrom);
    const dispatch = useDispatch();
    const { id } = useParams();
    const [license, setLicense] = useState();
    const [assets, setAssets] = useState([]);
    const [licenseKeys, setLicenseKeys] = useState([]);
    const navigate = useNavigate();
    const refreshState = useSelector(state => state.api.status);

    const [tab, setTab] = useState([
        {clicked: true, name: "기본정보"},
        {clicked: false, name: "이력관리"},
    ]);


    const addLicenseKey = async () => {
        const maxQty = Number(license.quantity) || 0;
        if (maxQty <= 0) {
            alert("라이선스 수량 먼저 입력해주세요");
            return;
        }
        if (licenseKeys.length < maxQty) {
            const check = await addLicenseKeyById(id);
            if (check) dispatch(refresh(true));
        } else {
            alert(`최대 ${maxQty}개의 라이선스 키만 추가할 수 있습니다.`);
        }
    };

    const removeLicenseKeyAndAsset = async (licenseKeyId) => {
        const response = await deleteLicenseKeyById(id, licenseKeyId);
        if (response) {
            setLicenseKeys((prevLicenseKeys) =>
                prevLicenseKeys.filter((key) => key.id !== licenseKeyId),
            );
            dispatch(skeleton(false));
            dispatch(refresh(true));
        } else {
            dispatch(skeleton(false));
        }
    };

    const hanlerDelete = async (v) => {
        const handlerIds = license.handler.map(handler => handler.id);
        if (handlerIds.length === 1){
            alert("담당자는 최소 한명이상 존재해야 합니다.")
            return;
        }else {
            const ckehck = await updateLicenseHandler(id, v.id, false);
            if(ckehck) {
                const filteredHandler = license.handler.filter(handler => handler.id !== v.id);
                setLicense(prev => ({...prev, handler: [...filteredHandler]}))
                dispatch(refresh(true));
            }
        }
    }

    const handleHandlersMultiFlat = async (list) => {
        const next = Array.isArray(list) ? list.filter(Boolean) : [];
        const prev = license.handler ?? [];
        const prevIds = new Set(prev.map((h) => h.id));
        const nextIds = new Set(next.map((h) => h.id));

        for (const item of next) {
            if (!prevIds.has(item.id)) {
                const check = await updateLicenseHandler(id, item.id, true);
                if (check) {
                    setLicense((p) => ({...p, handler: [...p.handler, item]}));
                    dispatch(refresh(true));
                }
            }
        }

        for (const item of prev) {
            if (!nextIds.has(item.id)) {
                await hanlerDelete(item);
            }
        }
    };





    useEffect(() => {
        if (!id) return;

        setLicense(undefined);
        setLicenseKeys([]);

        dispatch(skeleton(true));
        getLicense(id)
            .then((_) => {
                if (_.status === 200) {
                    setLicense(_.data);
                    const licenseKey = _.data.assets.map((item) => ({
                        ...item,
                        asset: [item.asset],
                    }));
                    setLicenseKeys(licenseKey);

                    setAssets({id: _.data.licenseAsset});
                    const assetArray = [];
                    assetArray.push(_.data.asset);
                    setAssets(assetArray);
                } else if (_.status === 201) {
                    alert(_.data.title + "\n" + _.data.reason);
                    navigate("/license");
                }
            })
            .then(() => {
                dispatch(skeleton(false));
                dispatch(refresh(false));
            })
            .catch((error) => {
                console.error("An error occurred:", error);
                dispatch(skeleton(false));
                dispatch(refresh(false));
            });
    }, [id, refreshState, dispatch, navigate]);


    function moveHandler(id){
        navigate(`/asset/`+id);
    }




    if(license){
    return (
        <div className="common-container container-height border-l-gray detail-list-layout asset-detail-list-layout">
            <DetailHeroSummaryProvider>
                <DetailTabBar tabs={tab} setTabs={setTab} />
            {tab[0].clicked && (
            <DetailEntityShell
                key={id}
                title={license.title || "라이선스상세"}
                meta={
                    license.quantity != null
                        ? `수량 ${license.quantity}${licenseKeys.length > 0 ? ` · 키 ${licenseKeys.length}건` : ""}`
                        : licenseKeys.length > 0
                          ? `총 ${licenseKeys.length}건`
                          : undefined
                }
                canUpdate={license.auth?.update ?? true}
                listUrl="/license"
                scrollMode="columns"
            >
            <LicenseDetailBody
                license={license}
                setLicense={setLicense}
                licenseKeys={licenseKeys}
                setLicenseKeys={setLicenseKeys}
                id={id}
                platFrom={platFrom}
                dispatch={dispatch}
                hanlerDelete={hanlerDelete}
                handleHandlersMultiFlat={handleHandlersMultiFlat}
                addLicenseKey={addLicenseKey}
                removeLicenseKeyAndAsset={removeLicenseKeyAndAsset}
                moveHandler={moveHandler}
            />
            </DetailEntityShell>
            )}

            {tab[1].clicked && <CommonHistoryList id={id} tableName={"라이선스관리"} />}
            </DetailHeroSummaryProvider>
        </div>
    );
}
}

function LicenseDetailBody({
    license,
    setLicense,
    licenseKeys,
    setLicenseKeys,
    id,
    platFrom,
    dispatch,
    hanlerDelete,
    handleHandlersMultiFlat,
    addLicenseKey,
    removeLicenseKeyAndAsset,
    moveHandler,
}) {
    const isEditing = useDetailEditing();
    const fieldAuth = isEditing && (license.auth?.update ?? true);

    const handleLicenseKeyChange = (index, value) => {
        setLicenseKeys((prev) => {
            const next = [...prev];
            next[index] = {...next[index], licenseKey: value, key: value};
            return next;
        });
    };

    const handleLicenseKeyCommit = (index, value, event, item) => {
        setLicenseKeys((prev) => {
            const next = [...prev];
            next[index] = {...next[index], licenseKey: value, key: value};
            return next;
        });

        const shouldCommit = event?.key === "Enter" || event?.type === "blur" || !event?.key;
        if (shouldCommit && item?.id) {
            updateLicenseKey({fieldName: "licenseKey", id: item.id, value}, id);
            dispatch(refresh(true));
        }
    };

    const handleLicenseAssetChange = (index, v, item) => {
        const newLicenseKeys = JSON.parse(JSON.stringify(licenseKeys));
        if (!Array.isArray(newLicenseKeys[index].asset)) {
            newLicenseKeys[index].asset = [v];
        } else {
            newLicenseKeys[index].asset[0] = v;
        }

        const selectedId = newLicenseKeys[index].asset[0]?.id;
        const prevId = item.asset?.[0]?.id;

        if (selectedId === prevId) {
            updateLicenseKeyAsset(id, selectedId, false, item.id);
            newLicenseKeys[index].asset[0] = null;
        } else if (selectedId) {
            updateLicenseKeyAsset(id, selectedId, true, item.id);
        }

        setLicenseKeys(newLicenseKeys);
    };

    return (
        <ContentDetailTwoColLayout
            main={
            <DetailPanel title="기본정보" className="license-basic-panel">
                <DetailKvTable>
                    <tbody>
                    <tr>
                        <DetailKvReadOnly label="등록일시" value={license.createdAt} type="date" />
                        <DetailKvReadOnly label="수정일시" value={license.updatedAt} type="date" />
                    </tr>
                    <tr>
                        <DetailKvReadOnly label="등록자" value={license.createdBy?.name} />
                        <DetailKvReadOnly label="수정자" value={license.updatedBy?.name} />
                    </tr>
                    <tr>
                        <Th_title title={"라이선스 명칭"} colspan={3} required={true} className="fieldset-td" auth={fieldAuth}>
                            <SimmsInput onChange={(v)=>inputOnChange(setLicense,"title", v, true)}
                                        update
                                        onKeyDown={(v, e)=>inputOnKeyDown(setLicense, updateLicense, id, "title", v, e, true)}
                                        data={license.title} />
                        </Th_title>

                    </tr>
                    <tr>
                        <Th_title title={"라이선스 사용기간"} colspan={3} className="fieldset-td fieldset-td-input"
                                  required={true} auth={fieldAuth}>

                            <div className="web-flex asset-detail-date-range">
                                <SimmsDatePicker
                                    onChange={(v) => dateOnChange(setLicense, "reqStartDate", v, true)}
                                    data={license.reqStartDate}
                                    update
                                    onUpdate={(v) => dateOnSelected(setLicense, updateLicense, id, "reqStartDate", v, true)}
                                    constraint={{lessThan: license.reqEndDate && dayjs(license.reqEndDate)}}
                                    auth={fieldAuth}/>
                                <span className={cn("ml-2 mr-1 text-[20px]")}> ~ </span>
                                <SimmsDatePicker
                                    onChange={(v) => dateOnChange(setLicense, "reqEndDate", v, true)}
                                    data={license.reqEndDate}
                                    update
                                    onUpdate={(v) => dateOnSelected(setLicense, updateLicense, id, "reqEndDate", v, true)}
                                    constraint={{largerThan: license.reqStartDate && dayjs(license.reqStartDate)}}
                                    auth={fieldAuth}/>
                            </div>
                        </Th_title>
                    </tr>
                    <tr className="license-kv-row--intro-handler">
                        <Th_title title={"라이선스 도입일시"} colspan={1} className="fieldset-td" required={true} auth={fieldAuth}>
                            <SimmsDatePicker onChange={(v) => dateOnChange(setLicense, "licenseStartDate", v, true)}
                                             update
                                             onUpdate={(v) => dateOnSelected(setLicense, updateLicense, id, "licenseStartDate", v, true)}
                                             data={license.licenseStartDate}/>

                        </Th_title>

                        <Th_title title={"담당자"} colspan={1} className="fieldset-td fieldset-td-input" required auth={fieldAuth}>
                            {isEditing ? (
                                <UserSelectionField
                                    layout="inline"
                                    data={license.handler}
                                    onRemove={(v) => hanlerDelete(v)}
                                >
                                    <SearchSelector
                                        auth={fieldAuth}
                                        multiSelect
                                        variant="compact"
                                        entity="userAccount"
                                        uniqueKey={UserType.handlers}
                                        data={license.handler}
                                        placeHolder="사용자명"
                                        onChange={(v) => {
                                            if (v?.__multiFlat) {
                                                handleHandlersMultiFlat(v.__multiFlat);
                                            }
                                        }}
                                    >
                                        <SimmsInputSearch type="TEXT" placeHolder="사용자명" />
                                        <SimmsDrawerSearch showLabel title="부서" entity="department" target="department" recursive />
                                        <SimmsDrawerSearch showLabel title="업체" entity="company" target="company" />
                                    </SearchSelector>
                                </UserSelectionField>
                            ) : (
                                <DetailKvListValue items={license.handler} listType={KV_LIST_TYPES.user} />
                            )}
                        </Th_title>

                    </tr>
                    <tr className="asset-detail-kv-row--auto license-kv-row--keys">
                        <Th_title title={"라이선스 키"} colspan={3} className="fieldset-td" auth={fieldAuth}>
                            <LicenseKeyEditor
                                licenseKeys={licenseKeys}
                                quantity={license.quantity}
                                onQuantityChange={(v) => inputOnChange(setLicense, "quantity", v, true)}
                                onQuantityCommit={(v, e) => {
                                    const qty = Number(v);
                                    if (!qty || qty <= 0) {
                                        alert("라이선스 수량을 입력해주세요");
                                        return;
                                    }
                                    if (qty < licenseKeys.length) {
                                        alert("라이선스 수량은 등록된 키 수 이상이어야 합니다.");
                                        return;
                                    }
                                    inputOnKeyDown(setLicense, updateLicense, id, "quantity", v, e, true);
                                }}
                                quantityUpdate={isEditing}
                                isEditing={isEditing}
                                fieldAuth={fieldAuth}
                                platFrom={platFrom}
                                onAdd={addLicenseKey}
                                onRemove={(item) => removeLicenseKeyAndAsset(item.id)}
                                onKeyChange={handleLicenseKeyChange}
                                onKeyCommit={handleLicenseKeyCommit}
                                onAssetChange={handleLicenseAssetChange}
                                onAssetNavigate={(asset) => moveHandler(asset.id)}
                            />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"비고사항"} colspan={3} className="fieldset-td" auth={fieldAuth}>
                            <SimmsTextArea onChange={(v) => inputOnChange(setLicense, "etc", v, true)}
                                           update
                                           style={{width: "100%"}}
                                           onKeyDown={(v, e) => inputOnKeyDown(setLicense, updateLicense, license.id, "etc", v, e, true)}
                                           data={license.etc}/>
                        </Th_title>
                    </tr>

                    </tbody>
                </DetailKvTable>
            </DetailPanel>
            }
            aside={
            <DetailFilePanel
                title="첨부"
                isEditing={isEditing}
                tableInfo={{tableName: "license", joinKey: id}}
            />
            }
        />
    );
}

export default LicenseView;
